import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META, { type WorkspaceAgentThreadListOpenedLocation } from './useTrackAgentThreadListOpened.meta';
import { withWorkspaceAgentCategory } from './workspaceAgentAnalytics';

export type { WorkspaceAgentThreadListOpenedLocation } from './useTrackAgentThreadListOpened.meta';

export type UseTrackAgentThreadListOpenedParams = {
  location: WorkspaceAgentThreadListOpenedLocation;
};

export const useTrackAgentThreadListOpened = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentThreadListOpened = useCallback(
    (params: UseTrackAgentThreadListOpenedParams) => {
      track(META.name, withWorkspaceAgentCategory(params));
    },
    [track],
  );

  return { trackAgentThreadListOpened };
};
